export const bannerdata = [
    {
      "id": "1",
      "name": "first video",
      "path": "Winter.png"
    },
    {
        "id": "2",
        "name": "second image",
        "path": "opening.gif"
    },
    // {
    //     "id": "4",
    //     "name": "fourth image",
    //     "path": "./image/car-4.png"
    // }
]


export const product =[
    {
        "id": 1,
        "brand" : "Marshell",
        "title": "Royal Antique Choker Necklace",
        "description": "A 22KT yellow gold traditional necklace (30.61 gms).",
        "description2" : "A 22KT yellow gold traditional necklace (30.61 gms). A delightful blend of ethnic and contemporary, this necklace will complement any look! (Without Back Chain)",
        "price": 2000.00,
        "product_code" : "ASD4565SS562",
        "currency": "₹",
        "categoryName" : "Home & Decor",
        "image": "https://shorturl.at/htFMW",
        "rating" : 2,
        "discounted":1857
    },
        {
            "id": 2,
            "brand" : "Marshell",
            "title": "royal wine set",
            "description": "This handcrafted rajasthani royal wine pattern is made of pure brass.",
            "price": 2556,
            "currency": "₹",
            "categoryName": "Lamps & Chandelier",
            "discounted": "1556",
            "product_code" : "ASD4565SS562",
            "image": "https://rb.gy/d4bd0m",
            "rating" : 5
          },
          {
            "id": 3,
            "brand" : "Marshell",
            "title": "Royal gifting box",
            "description": "Pure 925 sterling silver handmade nakashi /naxi work dry fruit box,",
            "currency": "₹",
            "categoryName" : "Lamps & Chandelier",
            "price": 3000,
            "product_code" : "ASD4565SS562",
            "image": "https://rb.gy/px7svm",
            "rating" : 3
          },
          {
            "id": 4,
            "brand" : "Marshell",
            "title": "royal wine set",
            "description": "This handcrafted rajasthani royal wine set in antique pattern is made.",
            "price": 25566,
            "currency": "₹",
            "categoryName" : "Lamps & Chandelier",
            "discounted": "15569",
            "product_code" : "ASD4565SS562",
            "image": "https://rb.gy/d4bd0m",
            "rating" : 4
          },
          {
            "id": 5,
            "brand" : "Marshell",
            "title": "Royal Antique Choker Necklace",
            "description": "A 22KT yellow gold traditional necklace (30.61 gms).",
            "description2" : "A 22KT yellow gold traditional necklace (30.61 gms). A delightful blend of ethnic and contemporary, this necklace will complement any look! (Without Back Chain)",
            "price": 217592.00,
            "product_code" : "ASD4565SS562",
            "currency": "₹",
            "categoryName" : "Lamps & Chandelier",
            "image": "https://shorturl.at/htFMW",
            "rating" : 2
          },
          {
            "id": 6,
            "brand" : "Kottanz",
            "title": "Metal Lantern Lamp Set of 3",
            "description": "A 22KT yellow gold traditional necklace (30.61 gms).",
            "description2" : "A 22KT yellow gold traditional necklace (30.61 gms). A delightful blend of ethnic and contemporary, this necklace will complement any look! (Without Back Chain)",
            "price": 1499.00,
            "discounted": 1099.00,
            "product_code" : "ASD4565SS562",
            "currency": "₹",
            "categoryName" : "Lamps & Chandelier",
            "image": "https://shorturl.at/erBQ8",
            "rating" : 4
          },
          {
            "id": 7,
            "brand" : "Marshell",
            "title": "Handmade Wooden Lamp",
            "description": "A 22KT yellow gold traditional necklace (30.61 gms).",
            "description2" : "Illuminate your living space with the warm and inviting glow of our Handmade Wooden Beautiful Lamp.",
            "price": 217592.00,
            "product_code" : "ASD4565SS562",
            "currency": "₹",
            "categoryName" : "Furniture & Carpets",
            "image": "https://shorturl.at/vxG68",
            "rating" : 3
          },
          {
            "id": 8,
            "brand" : "Marshell",
            "title": "Sacred Lord Ganesha Ceramic Idol",
            "description": "A 22KT yellow gold traditional necklace (30.61 gms).",
            "description2" : "A 22KT yellow gold traditional necklace (30.61 gms). A delightful blend of ethnic and contemporary, this necklace will complement any look! (Without Back Chain)",
            "price": 999,
            "product_code" : "ASD4565SS562",
            "currency": "₹",
            "categoryName" : "Furniture & Carpets",
            "image": "https://shorturl.at/suyYZ",
            "rating" : 3
          },
          {
            "id": 9,
            "brand" : "Marshell",
            "title": "Royal Antique Choker Necklace",
            "description": "A 22KT yellow gold traditional necklace (30.61 gms).",
            "description2" : "A 22KT yellow gold traditional necklace (30.61 gms). A delightful blend of ethnic and contemporary, this necklace will complement any look! (Without Back Chain)",
            "price": 217592.00,
            "product_code" : "ASD4565SS562",
            "currency": "₹",
            "categoryName" : "Furniture & Carpets",
            "image": "https://shorturl.at/htFMW",
            "rating" : 5
          },
          {
            "id": 10,
            "brand" : "Akriti Brass Art Wares",
            "title": "Antique Brass Bottle Vintage Look",
            "description": "(15.5 cm x 10 cm x 24.5 cm, Golden) 1000 ml Bottle Pack of 1 Bar Accessories Bar décor Utility Gift Decorative Bottle",
            "description2" : "This antique brass bottle can very well be used to keep water or wine. It is made up of original old monk bottle which has a brass case over it.",
            "price": 2192.00,
            "product_code" : "ASD4565SS562",
            "currency": "₹",
            "categoryName" : "Home & Decor",
            "image": "https://shorturl.at/htFMW",
            "rating" : 3,
            "material" : "Brass",
            "color" : "Gold",
            "quantity" : 15,
            "capacity" : "1000ml"
          }
]

export const user = [
    {
      "username":"ravi@gmail.com",
      "password":"raviyadav"
    }
  ]



  